import { insertItemsToConcreteIndex } from '../helper';
import getActualSortedOrder from './getActualSortedOrder';

export default (payloads, order, newPayloads) => {
  const data = insertItemsToConcreteIndex(payloads, order, newPayloads);

  return getActualSortedOrder(data);
};
